import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1eb683b5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1eb683b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb683b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb683b5')) {
      api.createRecord('1eb683b5', component.options)
    } else {
      api.reload('1eb683b5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1eb683b5&scoped=true", function () {
      api.rerender('1eb683b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-container-frame/index.vue"
export default component.exports